import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FundPostStatusEnumType } from '__generated__/graphql';
import { FC } from 'react';

import { FormInput, FormPanelWithReadMode } from 'components/FormPanel';

const UPDATE_FUND_POST_MUTATION = gql(`
  mutation UpdateFundPostStatus($id: ID!, $status: FundPostStatusEnumType!) {
    updateFundPostStatus(id: $id, status: $status) {
      id
      status
      updatedAt
    }
  }
`);

const UpdateFundPostStatus: FC<{
  id: string;
  status: FundPostStatusEnumType;
  canUpdatePostStatus: boolean;
  isBeingEdited?: (boolean) => void;
}> = ({ id, status, canUpdatePostStatus, isBeingEdited }) => {
  const [updatePost, { loading, error }] = useMutation(UPDATE_FUND_POST_MUTATION);

  const options = [
    { label: 'Draft', value: 'DRAFT' },
    { label: 'Under Review', value: 'UNDER_REVIEW' },
    { label: 'Published', value: 'PUBLISHED' },
    { label: 'Deleted', value: 'DELETED' },
  ];

  const optionsToShow = options.filter(option => {
    if (status === FundPostStatusEnumType.UnderReview)
      return option.value !== FundPostStatusEnumType.Published;
    return option;
  });

  return (
    <FormPanelWithReadMode
      loading={loading}
      error={error}
      disableEdit={!canUpdatePostStatus}
      isInReadOnlyMode={readOnlyMode => isBeingEdited && isBeingEdited(!readOnlyMode)}
      onSubmit={data => {
        updatePost({
          variables: {
            id,
            status: data.status,
          },
        });
      }}
    >
      <FormInput
        type="select"
        fieldName="status"
        label="Status"
        defaultValue={status}
        options={optionsToShow}
      />
    </FormPanelWithReadMode>
  );
};

export default UpdateFundPostStatus;
